import { API, PlanManagementAPI } from 'api/clients'
import { geoService } from 'modules/module-security'
import { all, fork } from 'redux-saga/effects'
import BillingService from '../services/BillingService'
import BillingSaga from './BillingSaga'

export default function* billingSagas() {
  yield all([fork(new BillingSaga(API, PlanManagementAPI, new BillingService(), geoService).supervise)])
}
